"use client";

import React from "react";
import { ArrowRight, Radio } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
function MancheteConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div data-section-id="130129" className="relative min-h-[80vh] flex items-center w-full bg-background">
        <div className="container relative z-10 mx-auto px-4 md:px-8 lg:px-12">
          <div className="max-w-3xl lg:max-w-4xl py-20 animate-pulse">
            <div className="h-6 w-32 bg-muted rounded mb-6"></div>
            <div className="h-24 md:h-40 w-full bg-muted rounded mb-6"></div>
            <div className="h-6 w-3/4 bg-muted rounded mb-8"></div>
            <div className="h-14 w-48 bg-muted rounded"></div>
          </div>
        </div>
      </div>;
  }
  if (error || !posts || posts.length === 0) {
    return null;
  }
  const post = posts[0];
  const category = post.categories?.[0]?.name || "Jurídico";
  const cleanExcerpt = post.excerpt ? post.excerpt.replace(/(<([^>]+)>)/gi, "") : "";
  return <div className="relative min-h-[80vh] flex items-center w-full bg-background">
      {/* Background organic shape replacement logic using the featured image at low opacity */}
      <div className="absolute top-0 right-0 w-full lg:w-[75%] h-full z-0 opacity-5 grayscale mix-blend-multiply">
        <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620776/img/hero_placeholder_news.png"} alt={post.title} className="w-full h-full object-contain" />
        {/* Gradients adjusted for light mode and subtle blending */}
        <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent lg:hidden" />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/60 to-transparent lg:via-background/20" />
      </div>

      {/* Content Container */}
      <div className="container relative z-10 mx-auto px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl lg:max-w-4xl py-20">
          <div className="flex items-center gap-4 mb-6">
            <Badge variant="secondary" className="uppercase tracking-widest font-default font-bold text-[10px] px-4 py-1.5 flex items-center gap-2 shadow-sm">
              <Radio className="w-3 h-3" />
              Atualizado em Outubro 2024
            </Badge>
            <span className="text-muted-foreground font-default font-semibold text-xs uppercase tracking-[0.2em]">
              {category}
            </span>
          </div>

          <h1 className="font-default font-bold text-4xl md:text-6xl lg:text-7xl leading-[1.1] tracking-tighter text-primary mb-6">
            {post.title}
          </h1>

          {cleanExcerpt && <p className="text-xl md:text-xl lg:text-2xl text-muted-foreground line-clamp-3 max-w-[60ch] mb-10 font-default font-normal leading-relaxed">
              {cleanExcerpt}
            </p>}

          <Link to={post.link || "#"}>
            <Button size="lg" className="bg-secondary text-secondary-foreground text-base px-10 h-14 rounded-full shadow-md hover:shadow-lg hover:bg-secondary/90 transition-all duration-300">
              Revisar Termos Agora
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </div>
    </div>;
}
export default function MancheteDoDia() {
  const wp_query_params = {
    per_page: 1,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="hero-de-termos" className="bg-background text-foreground relative w-full overflow-hidden border-b-2 border-secondary/10">
      <PostsProvider wp_query={{
      per_page: 1,
      orderby: "date",
      order: "desc"
    }}>
        <MancheteConsumer />
      </PostsProvider>
    </section>;
}